import { OpCo } from '../types/type';

export function opCoThemeIdMapper(opco: string, partnerName?: string) {
  switch (opco) {
    case OpCo.MSA:
      return 'D8958C3071714434';
    case OpCo.AMFAM:
      return 'C46502ED595BAD41';
    case OpCo.GEICO:
      return 'B7E4F1A2D9C83056';
    case OpCo.PROGRESSIVE:
      return 'F3A8E6B51C742D90';
    default:
      return 'C46502ED595BAD41';
  }
}
